import React, { useState } from 'react';
import { Tabs, Steps, Divider, Toast } from 'antd-mobile';
import './App.css';

const { Step } = Steps;

function App() {
  const [activeKey, setActiveKey] = useState('desc');

  const goDownload = () => {
    window.scrollTo({
      top: 0,
    });
    setActiveKey('download')
  };

  const onChange = (info) => {
    window.scrollTo({
      top: 0,
    });
    setActiveKey(info);
  };

  const copyToClipboard = (text) => {
    var textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    Toast.show({
      content: '已复制',
    });
  }

  return (
    <div className="wrap">
      <div className="header">
        <div className="titleImg"></div>
        <Tabs className="tabs" activeKey={activeKey} onChange={onChange}>
          <Tabs.Tab title="简介" key="desc">
            <div className="descWrap">
              <div style={{ backgroundColor: '#0F111D' }}>
                <div className="descImg"></div>
              </div>
              <div className="descLinearLine"></div>
              <div className="descDownColorWrap">
                <div className="descDownWrap">
                  <div className="descDownTitle">世界级扑克人工智能</div>
                  <div className="descDownDesc">协助您在牌桌上做出实时最佳行动</div>
                  <div className="descDownBtn" onClick={goDownload}>现在下载</div>
                </div>
                <div className="descPartLine"></div>
              </div>
              <div className="descColorWrap">
                <div className="descPartHead">
                  <div className="descPartIcon"></div>
                  <div className="descPartWrap">
                    <div className="descPartTitle">上亿手训练数据</div>
                    <div className="descPartDesc">PokerGPT手牌学习数量远超任何一个人类玩家，海量的高质量训练内容是PokerGPT的智能基础。</div>
                  </div>
                </div>
                <div className="descPartCt">
                  <div className="descPartIcon1"></div>
                  <div className="descPartWrap">
                    <div className="descPartTitle">精通GTO与剥削</div>
                    <div className="descPartDesc">PokerGPT非常精通GTO理论与剥削策略，决策时根据牌桌信息主动偏移，综合性分析做出决策。</div>
                  </div>
                </div>
                <div className="descPartCt" style={{ background: '#2C2B3B' }}>
                  <div className="descPartIcon2"></div>
                  <div className="descPartWrap">
                    <div className="descPartTitle">决策可用性 &gt; 98%</div>
                    <div className="descPartDesc">PokerGPT的失误率远低于人类玩家，误判概率不到2%，可轻松覆盖大部分牌局场景。</div>
                  </div>
                </div>
                <div className="descPartCt" style={{ background: '#272432' }}>
                  <div className="descPartIcon3"></div>
                  <div className="descPartWrap">
                    <div className="descPartTitle">2~3秒快速响应</div>
                    <div className="descPartDesc">分析、思考、纠错、决策等一些列流程，PokerGPT可在3秒内完成并将决策结果返回至用户界面。</div>
                  </div>
                </div>
                <div className="descPartBottom">
                  <div className="descPartIcon4"></div>
                  <div className="descPartWrap">
                    <div className="descPartTitle">安全防检测</div>
                    <div className="descPartDesc">PokerGPT通过图像识别这种合法的非侵入式方式来获取牌局信息。保护您的游戏账号安全稳定。</div>
                  </div>
                </div>
              </div>
              <div className="descAnalyWrap">
                <div className="descAnalyTitle">决策结果将置顶于您的屏幕上方</div>
                <div className="descAnalyImg"></div>
                <div className="commonTips">PokerGPT不能替代您完成行动操作<br />提供建议供您参考，行动需要您自行完成</div>
              </div>
              <div className="reasonWrap">
                <div className="reasonTitle">PokerGPT如何在iPhone上运作</div>
                <Steps
                  direction="vertical"
                  style={{
                    '--title-font-size': '17px',
                    '--description-font-size': '15px',
                    '--indicator-margin-right': '12px',
                    '--icon-size': '22px',
                  }}
                >
                  <Step
                    title="牌局信息获取"
                    description="使用屏幕录制权限，通过实时解析您的屏幕图像流获取牌局的所有信息。"
                    icon={1}
                  />
                  <Step
                    title="数据参数化处理"
                    description="在游戏中轮到您行动时，快速解析、校验，并参数化所有的牌局相关数据。"
                    icon={2}
                  />
                  <Step
                    title="神经网络决策"
                    description="神经网络通过标准化数据进行深度分析思考，并最终根据您的偏好完成行动决策。"
                    icon={3}
                  />
                  <Step
                    title="行动决策显示"
                    description="通过画中画功能权限，将决策结果显示在一个系统级置顶小窗口中，方便您实时查看。"
                    icon={4}
                  />
                </Steps>
              </div>
              <div className="aboutWrap">
                <div className="aboutTitle">关于输赢</div>
                <div className="aboutDescWrap" style={{ marginTop: '2rem' }}>
                  <div className="aboutDescLine"></div>
                  <div className="aboutDescTel">PokerGPT只能确保他给出的最佳行动是合理的，是正EV的。但他确实没法保证您一定会赢得底池。<br /><br />* 举一个极端的例子：<br />当您手持AA，在翻前4Bet All-in。您的动作是非常合理的，但是您依然有20%的概率跑马输给KK，对吧？</div>
                </div>
                <div className="aboutDescWrap">
                  <div className="aboutDescLine" style={{ height: '6.5rem' }}></div>
                  <div className="aboutDescTel">在扑克上研究正向EV是基于长期大数据样本下的一种概率科学。<br /><br />以任何短期的得利与失利去评估EV是不科学且错误的。这通常需要至少5000手牌才能初步达到评估标准。</div>
                </div>
              </div>
              <div className="downloadWrap">
                <div className="downloadCard">
                  <div className="downloadIcon"></div>
                  <div className="downloadDesc">快快体验一波<br />新注册免费体验30分钟</div>
                  <div className="downloadBtn" onClick={goDownload}>现在下载</div>
                  <div className="downloadTips">PokerGPT现已在TestFlight发布</div>
                </div>
                <div className="supTitle">· 支持范围</div>
                <Divider />
                <div className="supDescWrap">
                  <div className="supDescType">· 游戏平台：</div>
                  <div className="supDescTel">WePoker<span style={{ fontSize: '0.8rem', marginLeft: '0.5rem', color: 'rgba(255, 255, 255, 0.25)' }}>//将持续支持更多平台</span></div>
                </div>
                <div className="supDescWrap">
                  <div className="supDescType">· 游戏类型：</div>
                  <div className="supDescTel">
                    Cash Game<span style={{ fontSize: '0.8rem', marginLeft: '0.5rem', color: 'rgba(255, 255, 255, 0.25)' }}>(Private &amp; Public)</span>
                    <br />
                    4～9人 常规局 / 强抓局<span style={{ fontSize: '0.8rem', marginLeft: '0.5rem', color: 'rgba(255, 255, 255, 0.25)' }}>不限制 Ante</span>
                  </div>
                </div>
                <div className="supDescWrap">
                  <div className="supDescType">· 操作系统：</div>
                  <div className="supDescTel">iOS</div>
                </div>
                <div className="supDescWrap">
                  <div className="supDescType">· 机型支持：</div>
                  <div className="supDescTel">iPhone 12+</div>
                </div>
                <Divider />
                <div className="supDescWrap">
                  <div className="supDescType">· 特别注意：</div>
                  <div className="supDescTel">
                    不支持 MTT、短牌、PLO
                    <br />
                    不支持 鱿鱼游戏、幸运暴击
                  </div>
                </div>
                <div className="copyright">PokerGPT 2024 © Copyright</div>
              </div>
            </div>
          </Tabs.Tab>
          <Tabs.Tab title="代理" key="agency">
            <div className="agencyWrap">
              <div className="agencyTitle">招募中国区代理商</div>
              <div className="agencyDesc">
                PokerGPT是一款广受好评的扑克AI。目前团队正在中国区招募代理伙伴，我们为伙伴准备了相当可观的利润空间。
                <br /><br />
                如果您对成为PokerGPT的代理伙伴感兴趣，请通过邮件联系我们：
                <br /><br />
                <a href="mailto:hello@pokergpt.cc">hello@pokergpt.cc</a>
                <br /><br />
                麻烦您在邮件中对您的潜在客户资源规模与代理发展计划进行简要阐述。
                <br /><br />
                期待与您合作！
              </div>
            </div>
          </Tabs.Tab>
          <Tabs.Tab title="下载" key="download">
            <div className="downloadWrap1">
              <div className="downloadTipsWrap">
                <div className="tipsIcon"></div>
                <div className="downloadTips1">PokerGPT 仅通过 iOS TestFlight 受邀方式进行下载与安装。</div>
              </div>
              <Divider>如何下载安装</Divider>
              <Steps
                  direction="vertical"
                  style={{
                    '--title-font-size': '17px',
                    '--description-font-size': '15px',
                    '--indicator-margin-right': '12px',
                    '--icon-size': '22px',
                  }}
                >
                  <Step
                    title="在App Store中下载安装TestFlight"
                    description={(
                      <div className="flightWrap">
                          <div className="flightIcon"></div>
                          <div className="flightDesc">
                            TestFlight
                            <br />
                            <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.35)' }}>如果您已安装TestFlight，请忽略</span>
                          </div>
                        </div>
                    )}
                    icon={1}
                  />
                  <Step
                    title="在Safari浏览器中打开下方安装链接。"
                    description={(
                      <>
                        <a className="downloadUrl" href="https://testflight.apple.com/join/aBQh9F2u">https://testflight.apple.com/join/aBQh9F2u</a>
                        <div className="copyWrap">
                          <div className="copyIcon"></div>
                          <div className="copyDesc" onClick={copyToClipboard.bind(this, 'https://testflight.apple.com/join/aBQh9F2u')}>复制链接</div>
                        </div>
                      </>
                    )}
                    icon={2}
                  />
                  <Step
                    title="跳转至TestFlight后，点击“安装”"
                    icon={3}
                  />
                </Steps>
            </div>
          </Tabs.Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default App;
